import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import Router from 'vue-router'
import Enterprise from '@/pages/Enterprise'
import Index from '@/pages/Index'
import store from '../store/index'
import wxConfig from '../assets/js/wx_config.js'
import { postCnzzDataTrack, postCnzzData } from '../assets/js/util.js'
Vue.use(Router)

const router = new Router({
  base: '/commuter/dist',
  mode: 'history',
  routes: [{
    path: '/home',
    name: 'home',
    alias: '/',
    component: Index,
    meta: {
      need_login: false
    }
  }, {
    path: '/e/:enterprise_id',
    name: 'enterprise',
    component: Enterprise,
    meta: {
      need_login: false
    },
    children: [{
      path: '',
      name: 'index',
      component: Index,
      meta: {
        keep_alive: true,
        need_login: false
      }
    }, {
      path: 'commute/:id',
      name: 'index',
      component: Index,
      meta: {
        keep_alive: true,
        need_login: false
      }
    }, {
      path: 'wechatGroup',
      name: 'wechatGroup',
      component: function (resolve) {
        require(['../pages/WechatGroup.vue'], resolve)
      },
      meta: {
        title: '加入群聊',
        need_login: false
      }
    }, {
      path: 'customLine',
      name: 'customLine',
      component: function (resolve) {
        require(['../pages/CustomLine.vue'], resolve)
      },
      meta: {
        title: '定制开通',
        need_login: true
      }
    }, {
      path: 'collectLine',
      name: 'collectLine',
      component: function (resolve) {
        require(['../pages/CollectLine.vue'], resolve)
      },
      meta: {
        title: '我的收藏',
        need_login: true
      }
    }, {
      path: 'unopenLine/:line_id',
      name: 'unopenLine',
      component: function (resolve) {
        require(['../pages/UnopenLine.vue'], resolve)
      },
      meta: {
        title: '查看线路',
        need_login: false
      }
    }, {
      path: 'organizeLineSuccess/:line_id',
      name: 'organizeLineSuccess',
      component: function (resolve) {
        require(['../pages/OrganizeLineSuccess.vue'], resolve)
      },
      meta: {
        title: '提交成功',
        need_login: true
      }
    }, {
      path: 'organizeLine',
      name: 'organizeLine',
      component: function (resolve) {
        require(['../pages/OrganizeLine.vue'], resolve)
      },
      meta: {
        title: '发起线路',
        need_login: true
      }
    }, {
      path: 'setAddress/:from',
      name: 'setAddress',
      component: function (resolve) {
        require(['../pages/SetAddress.vue'], resolve)
      },
      meta: {
        title: '地址查询',
        need_login: false
      }
    }, {
      path: 'checkAddress/:from',
      name: 'checkAddress',
      component: function (resolve) {
        require(['../pages/CheckAddress.vue'], resolve)
      },
      meta: {
        title: '设置地址',
        need_login: false
      }
    }, {
      path: 'selectCity',
      name: 'selectCity',
      component: function (resolve) {
        require(['../pages/SelectCity.vue'], resolve)
      },
      meta: {
        title: '选择城市',
        need_login: false
      }
    }, {
      path: 'searchResult',
      name: 'searchResult',
      component: function (resolve) {
        require(['../pages/SearchResult.vue'], resolve)
      },
      meta: {
        keep_alive: true,
        title: '搜索结果',
        need_login: false
      }
    }, {
      path: 'searchResultOpt',
      name: 'searchResultOpt',
      component: function (resolve) {
        require(['../pages/SearchResultOpt.vue'], resolve)
      },
      meta: {
        keep_alive: true,
        title: '搜索结果',
        need_login: false
      }
    }, {
      path: 'lineDetail/:line_id',
      name: 'lineDetail',
      component: function (resolve) {
        require(['../pages/LineDetail.vue'], resolve)
      },
      meta: {
        title: '班次详情',
        need_login: false,
        need_init_wx: true
      }
    }, {
      path: 'mapDirection',
      name: 'mapDirection',
      component: function (resolve) {
        require(['../pages/mapDirection.vue'], resolve)
      },
      meta: {
        title: '线路导航',
        need_login: false,
        need_init_wx: true
      }
    }, {
      path: 'bug/:line_id',
      name: 'bug_ticket',
      component: function (resolve) {
        require(['../pages/BugTicket.vue'], resolve)
      },
      meta: {
        title: '购买车票',
        need_login: true,
        keep_alive: true
      }
    }, {
      path: 'pay',
      name: 'pay_detal',
      component: function (resolve) {
        require(['../pages/PayDetail.vue'], resolve)
      },
      meta: {
        title: '支付页面',
        need_login: true
      }
    }, {
      path: 'paySuccess',
      name: 'pay_success',
      component: function (resolve) {
        require(['../pages/PaySuccess.vue'], resolve)
      },
      meta: {
        title: '支付成功',
        need_login: false
      }
    }, {
      path: 'refundTicketRule',
      name: 'refund_ticket_rule',
      component: function (resolve) {
        require(['../pages/RefundTicketRule.vue'], resolve)
      },
      meta: {
        title: '退票规则',
        need_login: false
      }
    }, {
      path: 'lineDetailToBuy/:line_id',
      name: 'lineDetailToBuy',
      component: function (resolve) {
        require(['../pages/LineDetailToBuy.vue'], resolve)
      },
      meta: {
        title: '班次详情',
        need_login: false,
        need_init_wx: true
      }
    }, {
      path: 'usefulTicket',
      name: 'useful_ticket',
      component: function (resolve) {
        require(['../pages/UsefulTicket.vue'], resolve)
      },
      meta: {
        title: '当天可验车票',
        need_login: true,
        need_init_wx: true
      }
    }, {
      path: 'checkedRecord',
      name: 'checked_record',
      component: function (resolve) {
        require(['../pages/CheckedRecord.vue'], resolve)
      },
      meta: {
        title: '验票记录',
        need_login: true
      }
    }, {
      path: 'questions',
      name: 'questions',
      component: function (resolve) {
        require(['../pages/Questions.vue'], resolve)
      },
      meta: {
        title: '热门咨询',
        need_login: false
      }
    }, {
      path: 'sitePanorama',
      name: 'sitePanorama',
      component: function (resolve) {
        require(['../pages/SitePanorama.vue'], resolve)
      },
      meta: {
        title: '站点描述',
        need_login: false
      }
    }, {
      path: 'feedback',
      name: 'feedback',
      component: function (resolve) {
        require(['../pages/Feedback.vue'], resolve)
      },
      meta: {
        title: '问题反馈',
        need_login: true
      }
    }, {
      path: 'feedbackEnt',
      name: 'feedbackEnt',
      component: function (resolve) {
        require(['../pages/FeedbackEnt.vue'], resolve)
      },
      meta: {
        title: '线路反馈',
        need_login: true
      }
    }, {
      path: 'searchLine',
      name: 'searchLine',
      component: function (resolve) {
        require(['../pages/SearchLine.vue'], resolve)
      },
      meta: {
        title: '线路搜索',
        need_login: false
      }
    }, {
      path: 'searchMap',
      name: 'searchMap',
      component: function (resolve) {
        require(['../pages/SearchMap.vue'], resolve)
      },
      meta: {
        title: '位置选择',
        need_login: false
      }
    }, {
      path: 'feedbackSend',
      name: 'feedbackSend',
      component: function (resolve) {
        require(['../pages/FeedbackSend.vue'], resolve)
      },
      meta: {
        title: '线路反馈',
        need_login: true,
        keep_alive: true
      }
    }, {
      name: 'rater',
      path: 'rater',
      component: function (resolve) {
        require(['../pages/Rater.vue'], resolve)
      },
      meta: {
        title: '评价',
        need_login: true
      }
    }, {
      path: 'userInfo',
      name: 'userInfo',
      component: function (resolve) {
        require(['../pages/UserInfo.vue'], resolve)
      },
      meta: {
        title: '个人信息',
        need_login: true
      }
    }, {
      path: 'myMessage',
      name: 'myMessage',
      component: function (resolve) {
        require(['../pages/MyMessage.vue'], resolve)
      },
      meta: {
        title: '我的消息',
        need_login: true
      }
    }, {
      path: 'myOrder',
      name: 'myOrder',
      component: function (resolve) {
        require(['../pages/MyOrder.vue'], resolve)
      },
      meta: {
        title: '我的订单',
        need_login: true
      }
    }, {
      path: 'orderDetail/:orderNumber',
      name: 'order_detail',
      component: function (resolve) {
        require(['../pages/OrderDetail.vue'], resolve)
      },
      meta: {
        title: '订单详情',
        need_login: true
      }
    }, {
      path: 'messageDetail/:message_id',
      name: 'messageDetail',
      component: function (resolve) {
        require(['../pages/MessageDetail.vue'], resolve)
      },
      meta: {
        // title: '我的消息',
        need_login: false
      }
    }, {
      path: 'feedbackDetail/:message_id',
      name: 'feedbackDetail',
      component: function (resolve) {
        require(['../pages/FeedbackDetail.vue'], resolve)
      },
      meta: {
        title: '反馈详情',
        need_login: true
      }
    }, {
      path: 'evaluateDetail/:message_id',
      name: 'evaluateDetail',
      component: function (resolve) {
        require(['../pages/EvaluateDetail.vue'], resolve)
      },
      meta: {
        title: '评价详情',
        need_login: true
      }
    }, {
      path: 'notice/:notice_id',
      name: 'notice',
      component: function (resolve) {
        require(['../pages/Notice.vue'], resolve)
      },
      meta: {
        title: '公告信息',
        need_login: false
      }
    }, {
      path: 'login',
      name: 'login',
      component: function (resolve) {
        require(['../pages/Login.vue'], resolve)
      },
      meta: {
        title: '登录',
        need_login: false
      }
    }, {
      path: 'help',
      name: 'help',
      component: function (resolve) {
        require(['../pages/Help.vue'], resolve)
      },
      meta: {
        title: '帮助与反馈',
        need_login: false
      },
      children: [{
        path: ':categroy_id',
        name: 'help',
        component: function (resolve) {
          require(['../pages/Help.vue'], resolve)
        },
        meta: {
          title: '帮助与反馈',
          need_login: false
        }
      }, {
        path: ':categroy_id/:question_id',
        name: 'help',
        component: function (resolve) {
          require(['../pages/Help.vue'], resolve)
        },
        meta: {
          title: '帮助与反馈',
          need_login: false
        }
      }]
    }]
  }]
})

let init_base = false
let init_login = false
let set_enterprise_id = false
let init_wx = false
let init_wx_status = false
let get_enterprise_nav = false

window.reportEvent = function (text) {
  if (window.location.origin === 'https://wx.dudubashi.com') {
    console.log('tdapp上报123')
    try {
      if (TDAPP && TDAPP.onEvent) {
        TDAPP.onEvent(text)
      }
    } catch (e) {
    }
  // }else {
  //   console.log('不上报埋点')
  }
}
// 初始化页面时，保存进入页面的 href ,微信下ios 授权使用第一次进入页面的href
store.commit('UPDATE_ENTRY_HREF', location.href.split('#')[0])
router.beforeEach((to, from, next) => {
  // 兼容旧链接
  if (to.path === '/e/43/commute/' || to.path === '/e/43/commute') {
    goNext({
      path: '/e/43/',
      query: to.query
    })
  } else if (store.getters.link_param_cache && !to.query.lng) {
    // 所有跳转都要把华为的链接参数带上，以便后续取
    var cacheQuery = to.query
    cacheQuery.lng = store.getters.link_param_cache.lng || ''
    cacheQuery.lat = store.getters.link_param_cache.lat || ''
    cacheQuery.city_name = store.getters.link_param_cache.city_name || ''
    goNext({
      path: to.path,
      query: cacheQuery || {}
    })
  } else {
    if (!set_enterprise_id && to.params.enterprise_id) {
      // 设置企业id
      store.dispatch('setEnterpriseId', to.params.enterprise_id)
      set_enterprise_id = true
    }
    // 先判断是否已经在单页面登录
    if (store.getters.is_login) {
      goNext()
    } else {
      // 判断是否查询过用户信息，不重复请求
      if (!init_login) {
        init_login = true
        // 先查询用户信息
        const _result = store.dispatch('autoLogin')
        _result.then(function (_res) {
          // 当前页面需要登录
          if (to.meta.need_login) {
            if (!_res.data.login) {
              var path = '/login?from=' + encodeURIComponent(to.fullPath)
              if (store.getters.enterprise_id) {
                path = '/e/' + store.getters.enterprise_id + path
              }
              goNext({path: path})
            } else {
              goNext()
            }
          } else {
            goNext()
          }
        })
      } else {
        if (to.meta.need_login) {
          var path = '/login?from=' + encodeURIComponent(to.fullPath)
          if (store.getters.enterprise_id) {
            path = '/e/' + store.getters.enterprise_id + path
          }
          goNext({path: path})
        } else {
          goNext()
        }
      }
    }
  }
  function goNext (param) {
    // 下一步
    if (!get_enterprise_nav && to.params.enterprise_id) {
      // 获取导航，涉及页面（关注列表）
      get_enterprise_nav = true
      store.dispatch('getHomePageNav')
    }
    if (param) {
      next(param)
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
  store.commit('UPDATE_BACK_PATH', to.path !== '/' ? from.path : '') // 返回历史页面
  if (from.path) {
    // 缓存来源页面
    store.commit('UPDATE_PAGE_FROM', from.path)
  }
  var url = window.location.href
  // 去除hash后面的字符
  var _hash = window.location.hash || ''
  if (_hash) {
    url = url.replace(_hash, '')
  }
  if (!init_base) {
    init_base = true
    if (to.query.lng || to.query.city_name) {
      // 华为统计
      postCnzzData('9.2.1 渠道来源new', 'iadmin')
    } else {
      if (store.getters.is_wx) {
        postCnzzData('9.2.1 渠道来源new', '微信')
      } else {
        postCnzzData('9.2.1 渠道来源new', '其他')
      }
    }
    if (!store.getters.current_pos) {
      // 第一次进入页面进行缓存华为链接带过来的参数
      if (!store.getters.link_param_cache && to.query.lng) {
        store.commit('UPDATE_LINK_PARAM_CACHE', to.query)
        store.dispatch('setParamCurrentPos', {
          lng: to.query.lng,
          lat: to.query.lat
        })
        if (to.query.city_name) {
          store.dispatch('setCurrentCity', to.query.city_name)
        }
      } else {
        if (store.getters.is_wx && !init_wx) {
          init_wx = true
          init_wx_status = true
          var _wx_config = store.dispatch('wxConfigFun', url)
          _wx_config.then(function (data) {
            if (data) {
              wxConfig(data, function () {
                // 失败重新授权
                var reInitConfig = store.dispatch('wxConfigFun', '')
                reInitConfig.then(function (data) {
                  if (data) {
                    wxConfig(data)
                  }
                })
              })
              var _r = store.dispatch('getWXLocation')
              _r.then(function (point) {
                if (point) {
                  store.dispatch('setParamCurrentPos', {
                    lng: point.lng,
                    lat: point.lat
                  })
                } else {
                  // 失败，重新调用百度地图的api
                  store.dispatch('getCurrentCity', true)
                }
              }, function () {
                // 失败，重新调用百度地图的api
                store.dispatch('getCurrentCity', true)
              })
            }
          })
        } else {
          store.dispatch('getCurrentCity', true)
        }
      }
    }
  }
  // 由于微信初始化config 时会根据url 进行变动所以需要在页面中调用微信接口的，必须重新再配置一次
  if (store.getters.is_wx && !init_wx_status) {
    // 增加ios 分享配置，ios 下分享，由于url 变化，会导致分享链接不同
    if ((to.meta && to.meta.need_init_wx) || (to.name === 'index' || to.name === 'lineDetailToBuy' || to.name === 'lineDetail') && !store.getters.is_android) {
      url = window.location.href
      var _wx_config_cache = ''
      if (from.fullPath === '/') {
        _wx_config_cache = store.dispatch('wxConfigFun', (window.location.protocol + '//' + window.location.hostname + '/commuter/dist') + to.fullPath)
      } else {
        _wx_config_cache = store.dispatch('wxConfigFun', url.replace(from.fullPath, to.fullPath))
      }
      _wx_config_cache.then(function (data) {
        if (data) {
          wxConfig(data, function () {
            // 失败重新授权
            var reInitConfig = store.dispatch('wxConfigFun', '')
            reInitConfig.then(function (data) {
              if (data) {
                wxConfig(data)
              }
            })
          })
        }
      })
    }
  }
  init_wx_status = false
  postCnzzDataTrack(to.fullPath, from.fullPath)
  if (store.getters.is_wx && window.scrollTo && !store.getters.is_android) {
    // 回滚页面到顶部，防止ios 微信端bug
    window.scrollTo(0, 0)
  }
})

sync(store, router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js